"use strict";

exports.__esModule = true;
exports.equalsNaN = equalsNaN;

function equalsNaN(floatValue) {
  //http://adripofjavascript.com/blog/drips/the-problem-with-testing-for-nan-in-javascript.html
  // NaN is the only value in JavaScript that is not equal to itself
  return floatValue !== floatValue;
}